// extracted by mini-css-extract-plugin
module.exports = {"grid":"bj_b2","logoContainer":"bj_fW"};